<template>
  <div class="auth-container">
    <div class="container-fluid">
      <div class="row flex">
        <div class="col-12 col-md-12 col-lg-6 max-h-screen overflow-y-auto order-2 lg:order-1">
          <div class="mt-8 flex justify-center">
            <muleex-logo />
          </div>
          <slot></slot>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 bg-wrapper flex items-center flex-col justify-center relative  order-1 lg:order-2"
        >
        <router-link to="/signup">
          <div class="home-icon absolute top-0 right-0 pr-4 pt-4 hidden lg:inline-block">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27.0902 16.2296L14.6008 0.361399C14.5109 0.246836 14.4041 0.155947 14.2865 0.0939336C14.1689 0.0319202 14.0429 0 13.9156 0C13.7883 0 13.6622 0.0319202 13.5446 0.0939336C13.4271 0.155947 13.3202 0.246836 13.2303 0.361399L0.74094 16.2296C0.377084 16.6923 0.170898 17.3207 0.170898 17.9761C0.170898 19.337 1.04112 20.4434 2.11147 20.4434H3.42741V31.7663C3.42741 32.4487 3.86101 33 4.3977 33H11.975V24.3642H15.371V33H23.4335C23.9701 33 24.4037 32.4487 24.4037 31.7663V20.4434H25.7197C26.2351 20.4434 26.7294 20.1851 27.0932 19.7186C27.8482 18.7548 27.8482 17.1934 27.0902 16.2296Z"
                fill="white"
              />
            </svg>
          </div>
        </router-link>
          <div class="px-1 w-4/5">
            <slot name="text"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MuleexLogo from "@/components/UI/svgs/MuleexLogo";

export default {
  components: {
    MuleexLogo,
  },
};
</script>

<style scoped>
.home-icon{
  cursor: pointer;
}
.auth-container {
  /* min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  /* margin: 2rem 0; */
}

.bg-wrapper {
  width: 100%;
  height: auto;
  padding-top: 1em;
  padding-bottom: 1em;
  max-height: 100vh;
  min-height: 0px;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  /* background: linear-gradient(rgba(19, 19, 19, 0.8), rgba(19, 19, 19, 0.2)), */
  background: linear-gradient(rgba(255, 255, 255, 0.2), rgba(19, 19, 19, 0.2)),url(/img/auth-bg.43990ebe.png);
  filter: brightness(2.5);
}
@media screen and (min-width: 992px) {
  .bg-wrapper {
    filter: brightness(2.5);
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    /* background: linear-gradient(rgba(19, 19, 19, 0.8), rgba(19, 19, 19, 0.2)), */
    background: linear-gradient(rgba(255, 255, 255, 0.2), rgba(19, 19, 19, 0.2)),url(/img/auth-bg.43990ebe.png);
  }
}
.row > div:first-of-type::-webkit-scrollbar {
  width: 0px;
}

@media screen and (max-width: 768px) {
}
</style>
